import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GeneralDashboardComponent } from './general-dashboard.component';
import { Routes, RouterModule } from '@angular/router';
import { SharedModule } from '../../../core/modules/shared.module';
import { FuseWidgetModule } from '../../../core/components/widget/widget.module';
import { SelectorModule } from '../selector/selector.module';

const routes: Routes = [
  {
      path     : 'general-dashboard',
      component: GeneralDashboardComponent
  }
];

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild(routes),
    FuseWidgetModule,
    SelectorModule
  ],
  declarations: [GeneralDashboardComponent]
})
export class GeneralDashboardModule { }



// WEBPACK FOOTER //
// ./src/app/main/content/general-dashboard/general-dashboard.module.ts